import { Component, inject, Input } from '@angular/core';
import { ITab, TabsComponent } from '@tecalisdev/infinity';
import { IOperationDetailResponse } from '../../models/operations.models';
import { OperationsHelperService } from '../../services/operations-helper.service';
import { OperationDetailTabsActivityComponent } from './operation-detail-tabs-activity/operation-detail-tabs-activity.component';
import { OperationDetailTabsChecksComponent } from './operation-detail-tabs-checks/operation-detail-tabs-checks.component';
import { OperationDetailTabsDetailsComponent } from './operation-detail-tabs-details/operation-detail-tabs-details.component';

@Component({
	selector: 'app-operation-detail-tabs',
	imports: [
		TabsComponent,
		OperationDetailTabsDetailsComponent,
		OperationDetailTabsChecksComponent,
		OperationDetailTabsActivityComponent,
	],
	templateUrl: './operation-detail-tabs.component.html',
	styleUrl: './operation-detail-tabs.component.scss',
})
export class OperationDetailTabsComponent {
	@Input() detail: IOperationDetailResponse;

	private operationsHelper = inject(OperationsHelperService);

	public tabs: ITab[] = this.operationsHelper.tabsDetail;
}
